function Loading() {
    return (
        <div className="gh-loading-content">
            <div className="gh-loading-spinner" data-testid="gh-loading-spinner"></div>
        </div>
    );
}

export default Loading;
